import LandingPage from './LandingPage';

export default { LandingPage };



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/index.js